module.exports = __webpack_public_path__ + "static/media/2.0bce5c03.svg";